import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import { createPinia } from 'pinia'
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import './assets/css/global.css';
import ArgonDashboard from "./argon-dashboard";

const appInstance = createApp(App);
appInstance.config.globalProperties.storage_path = `${process.env.VUE_APP_STORAGE_URL}`

const pinia = createPinia();
appInstance.use(pinia);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.mount("#app");
